(function () {
  'use strict';

  var STORAGE_BASE = 'nb_wishlist_v1';
  var GUEST_KEY = STORAGE_BASE + ':guest';
  var API_BASE = '/apps/nb-wishlist';
  var MAX_ITEMS = 500;

  function getCustomerKey() {
    var el = document.querySelector('[data-nb-customer-id]');
    var id = el && el.getAttribute('data-nb-customer-id');
    if (id) return STORAGE_BASE + ':c:' + id;
    return null;
  }

  function safeJsonParse(v, fallback) {
    try { return JSON.parse(v); } catch (e) { return fallback; }
  }

  function absolutizeUrl(url) {
    if (!url) return null;

    var value = String(url).trim();
    if (!value) return null;

    if (value.indexOf('//') === 0) {
      return window.location.protocol + value;
    }

    if (value.indexOf('/') === 0) {
      return window.location.origin + value;
    }

    return value;
  }

  function readList(key) {
    var raw = localStorage.getItem(key);
    var list = safeJsonParse(raw, []);
    if (!Array.isArray(list)) return [];

    return list.filter(function (x) {
      return x && (x.handle || x.id || x.productId);
    });
  }

  function writeList(key, list) {
    localStorage.setItem(key, JSON.stringify((list || []).slice(0, MAX_ITEMS)));
  }

  function itemKey(it) {
    if (!it) return null;
    if (it.handle) return 'h:' + String(it.handle);
    if (it.id) return 'id:' + String(it.id);
    if (it.productId) return 'id:' + String(it.productId);
    return null;
  }

  function uniqByHandleOrId(list) {
    var seen = Object.create(null);
    var out = [];

    for (var i = 0; i < list.length; i++) {
      var it = list[i];
      var k = itemKey(it);
      if (!k || seen[k]) continue;
      seen[k] = true;
      out.push(it);
    }

    return out;
  }

  function getActiveKey() {
    return getCustomerKey() || GUEST_KEY;
  }

  function normalizeLocalItem(item) {
    return {
      id: item.id || item.productId || item.product_id || null,
      productId: item.productId || item.product_id || item.id || null,
      handle: item.handle || null,
      variantId: item.variantId || item.variant_id || null,
      title: item.title || null,
      imageUrl: absolutizeUrl(item.imageUrl || item.image_url || null),
      productUrl: absolutizeUrl(item.productUrl || item.product_url || null),
      priceCents: item.priceCents || item.price_cents || null,
      currency: item.currency || null,
      available: typeof item.available === 'boolean' ? item.available : null,
      addedAt: item.addedAt || Date.now()
    };
  }

  function normalizeBackendItem(item) {
    return normalizeLocalItem({
      id: item.productId || item.id || null,
      productId: item.productId || item.id || null,
      handle: item.handle || null,
      variantId: item.variantId || null,
      title: item.title || null,
      imageUrl: item.imageUrl || null,
      productUrl: item.productUrl || null,
      priceCents: item.priceCents || null,
      currency: item.currency || null,
      available: typeof item.available === 'boolean' ? item.available : null,
      addedAt: item.createdAt ? Date.parse(item.createdAt) || Date.now() : Date.now()
    });
  }

  function migrateGuestToCustomerIfNeeded() {
    var ck = getCustomerKey();
    if (!ck) return;

    var guest = readList(GUEST_KEY);
    if (!guest.length) return;

    var cust = readList(ck);
    var merged = uniqByHandleOrId(guest.concat(cust));

    writeList(ck, merged);
    localStorage.removeItem(GUEST_KEY);
  }

  function getCount() {
    return readList(getActiveKey()).length;
  }

  function setHeaderCount(n) {
    var wrap = document.querySelector('[data-nb-wl-count-wrap]');
    var num = document.querySelector('[data-nb-wl-count]');
    if (!wrap || !num) return;

    if (n > 0) {
      wrap.hidden = false;
      num.textContent = String(n > 9999 ? 9999 : n);
    } else {
      wrap.hidden = true;
      num.textContent = '0';
    }
  }

  function refreshHeaderAndButtons() {
    setHeaderCount(getCount());
    syncButtons();
  }

  function isInWishlist(handleOrId) {
    var list = readList(getActiveKey());
    var k = String(handleOrId);

    for (var i = 0; i < list.length; i++) {
      var it = list[i];
      if (String(it.handle || it.id || it.productId) === k) return true;
    }

    return false;
  }

  function addItem(item) {
    var key = getActiveKey();
    var list = readList(key);

    list.unshift(normalizeLocalItem(item));
    list = uniqByHandleOrId(list);

    writeList(key, list);
    backendAddItem(item);

    return list.length;
  }

  function removeItem(handleOrId, productId) {
    var key = getActiveKey();
    var h = handleOrId ? String(handleOrId) : null;
    var pid = productId ? String(productId) : null;

    var list = readList(key).filter(function (it) {
      var itHandle = it.handle ? String(it.handle) : null;
      var itId = (it.id || it.productId) ? String(it.id || it.productId) : null;

      if (h && itHandle === h) return false;
      if (pid && itId === pid) return false;
      if (h && itId === h) return false;

      return true;
    });

    writeList(key, list);

    backendRemoveItem({
      handle: h,
      id: pid || null,
      productId: pid || null
    });

    return list.length;
  }

  function removeMany(handles) {
    if (!handles || !handles.length) return;

    var key = getActiveKey();
    var removeMap = Object.create(null);

    handles.forEach(function (h) {
      removeMap[String(h)] = true;
      backendRemoveItem({ handle: h });
    });

    var next = readList(key).filter(function (it) {
      var h = it.handle ? String(it.handle) : '';
      return !removeMap[h];
    });

    writeList(key, next);
  }

  function mergeBackfilledItems(backfilledItems) {
    if (!backfilledItems || !backfilledItems.length) return;

    var key = getActiveKey();
    var current = readList(key);
    var byKey = Object.create(null);

    current.forEach(function (it) {
      var k = itemKey(it);
      if (k) byKey[k] = normalizeLocalItem(it);
    });

    backfilledItems.forEach(function (it) {
      var normalized = normalizeLocalItem(it);
      var k = itemKey(normalized);
      if (!k) return;

      byKey[k] = Object.assign({}, byKey[k] || {}, normalized);
    });

    var merged = [];
    current.forEach(function (it) {
      var k = itemKey(it);
      if (k && byKey[k]) {
        merged.push(byKey[k]);
        delete byKey[k];
      }
    });

    Object.keys(byKey).forEach(function (k) {
      merged.unshift(byKey[k]);
    });

    writeList(key, uniqByHandleOrId(merged));
  }

  async function apiFetch(path, options) {
    var response = await fetch(API_BASE + path, Object.assign({
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }, options || {}));

    var data = await response.json().catch(function () {
      return null;
    });

    if (!response.ok) {
      throw new Error((data && data.error) || 'Wishlist API failed');
    }

    return data;
  }

  function backendAddItem(item) {
    if (!getCustomerKey()) return;

    apiFetch('/items', {
      method: 'POST',
      body: JSON.stringify({
        item: normalizeLocalItem(item || {})
      })
    }).catch(function (err) {
      console.warn('NB Wishlist backend add skipped:', err.message);
    });
  }

  function backendRemoveItem(item) {
    if (!getCustomerKey()) return;

    apiFetch('/items', {
      method: 'DELETE',
      body: JSON.stringify({
        item: normalizeLocalItem(item || {})
      })
    }).catch(function (err) {
      console.warn('NB Wishlist backend remove skipped:', err.message);
    });
  }

  async function syncBackendWishlist() {
    if (!getCustomerKey()) return;

    var key = getActiveKey();
    var localItems = readList(key).map(normalizeLocalItem);

    try {
      var merged = await apiFetch('/merge', {
        method: 'POST',
        body: JSON.stringify({
          items: localItems
        })
      });

      if (merged && merged.mode === 'customer' && Array.isArray(merged.items)) {
        var backendItems = merged.items.map(normalizeBackendItem);
        writeList(key, uniqByHandleOrId(backendItems));
        refreshHeaderAndButtons();

        if (document.querySelector('[data-nb-wishlist-page]')) {
          renderWishlistPage();
        }
      }
    } catch (err) {
      console.warn('NB Wishlist backend sync skipped:', err.message);
    }
  }

  function syncButtons() {
    var btns = document.querySelectorAll('[data-nb-wl-btn]');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      var handle = btn.getAttribute('data-nb-wl-handle');
      var pid = btn.getAttribute('data-nb-wl-id');
      var key = handle || pid;
      if (!key) return;

      var active = isInWishlist(key);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function buildItemFromButton(btn) {
    var availableRaw = btn.getAttribute('data-nb-wl-available');

    return normalizeLocalItem({
      id: btn.getAttribute('data-nb-wl-id') || null,
      productId: btn.getAttribute('data-nb-wl-id') || null,
      handle: btn.getAttribute('data-nb-wl-handle') || null,
      variantId: btn.getAttribute('data-nb-wl-variant-id') || null,
      title: btn.getAttribute('data-nb-wl-title') || null,
      imageUrl: btn.getAttribute('data-nb-wl-image') || null,
      productUrl: btn.getAttribute('data-nb-wl-url') || null,
      priceCents: btn.getAttribute('data-nb-wl-price')
        ? Number(btn.getAttribute('data-nb-wl-price'))
        : null,
      currency: btn.getAttribute('data-nb-wl-currency') || null,
      available: availableRaw === 'true'
    });
  }

  function onBtnClick(e) {
    var btn = e.target && e.target.closest
      ? e.target.closest('[data-nb-wl-btn]')
      : null;

    if (!btn) return;

    e.preventDefault();

    var item = buildItemFromButton(btn);
    var key = item.handle || item.id;

    if (!key) return;

    if (isInWishlist(key)) {
      removeItem(item.handle || item.id, item.id);
    } else {
      addItem(item);
    }

    refreshHeaderAndButtons();

    if (document.querySelector('[data-nb-wishlist-page]')) {
      renderWishlistPage();
    }
  }

  async function fetchProductSafe(handle) {
    if (!handle) {
      return { ok: false, handle: handle, hardFail: false };
    }

    try {
      var response = await fetch(
        '/products/' + encodeURIComponent(handle) + '.js',
        { credentials: 'same-origin' }
      );

      if (response.status === 404) {
        return { ok: false, handle: handle, hardFail: true };
      }

      if (!response.ok) {
        return { ok: false, handle: handle, hardFail: false };
      }

      var product = await response.json();

      if (!product || !product.handle) {
        return { ok: false, handle: handle, hardFail: true };
      }

      return { ok: true, handle: handle, product: product };
    } catch (e) {
      return { ok: false, handle: handle, hardFail: false };
    }
  }

  function productToWishlistItem(p) {
    var firstAvail =
      (p.variants || []).find(function (v) { return v.available; })
      || (p.variants || [])[0];

    return normalizeLocalItem({
      id: p.id || null,
      productId: p.id || null,
      handle: p.handle || null,
      variantId: firstAvail ? firstAvail.id : null,
      title: p.title || null,
      imageUrl: (p.images && p.images[0]) ? p.images[0] : null,
      productUrl: p.url || (p.handle ? '/products/' + p.handle : null),
      priceCents: p.price || null,
      currency: null,
      available: typeof p.available === 'boolean' ? p.available : null
    });
  }

  function formatMoney(cents) {
    try { return (cents / 100).toFixed(2); } catch (e) { return ''; }
  }

  function escapeHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderWishlistCards(grid, items) {
    var html = '';

    items.forEach(function (item) {
      var title = item.title || item.handle || 'Любим продукт';
      var url = item.productUrl || (item.handle ? '/products/' + item.handle : '#');
      var img = item.imageUrl || '';
      var price = item.priceCents ? formatMoney(item.priceCents) : '';
      var variantId = item.variantId || null;
      var productId = item.productId || item.id || '';

      html += ''
        + '<div class="nb-wl-card" role="listitem">'
        + (
          img
            ? '<a href="' + escapeHtml(url) + '" class="nb-wl-card__link">'
                + '<img class="nb-wl-card__img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(title) + '" loading="lazy">'
              + '</a>'
            : ''
        )
        + '<a href="' + escapeHtml(url) + '" class="nb-wl-card__title">'
          + escapeHtml(title)
          + '</a>'
        + (
          price
            ? '<div class="nb-wl-card__price">' + escapeHtml(price) + '</div>'
            : ''
        )
        + '<div class="nb-wl-card__actions">'
        + (
          variantId
            ? '<button type="button" class="nb-wl-card__btn" data-nb-wl-atc data-variant-id="' + escapeHtml(variantId) + '">Добави в количка</button>'
            : ''
        )
        + '<button'
          + ' type="button"'
          + ' class="nb-wl-card__btn"'
          + ' data-nb-wl-remove'
          + ' data-product-handle="' + escapeHtml(item.handle || '') + '"'
          + ' data-product-id="' + escapeHtml(productId) + '">'
          + 'Премахни'
          + '</button>'
        + '</div>'
        + '</div>';
    });

    grid.innerHTML = html;
  }

  function renderWishlistPage() {
    var root = document.querySelector('[data-nb-wishlist-page]');
    if (!root) return;

    var list = readList(getActiveKey()).map(normalizeLocalItem);

    if (!list.length) {
      root.innerHTML = '<p style="margin:0">Нямаш добавени любими продукти.</p>';
      return;
    }

    root.innerHTML = '<div class="nb-wl-grid" role="list"></div>';
    var grid = root.querySelector('.nb-wl-grid');

    renderWishlistCards(grid, list);

    var handles = list.map(function (it) { return it.handle; }).filter(Boolean);
    if (!handles.length) return;

    Promise.all(handles.map(fetchProductSafe))
      .then(function (results) {
        var validItems = [];
        var hardFailedHandles = [];

        results.forEach(function (res) {
          if (res.ok && res.product) {
            validItems.push(productToWishlistItem(res.product));
            return;
          }

          if (res.hardFail && res.handle) {
            hardFailedHandles.push(res.handle);
          }
        });

        if (validItems.length) {
          mergeBackfilledItems(validItems);

          validItems.forEach(function (item) {
            backendAddItem(item);
          });

          renderWishlistCards(grid, readList(getActiveKey()).map(normalizeLocalItem));
        }

        if (hardFailedHandles.length) {
          removeMany(hardFailedHandles);
          refreshHeaderAndButtons();

          var afterCleanup = readList(getActiveKey()).map(normalizeLocalItem);
          if (afterCleanup.length) {
            renderWishlistCards(grid, afterCleanup);
          } else {
            root.innerHTML = '<p style="margin:0">Няма налични любими продукти.</p>';
          }
        }
      })
      .catch(function () {
        renderWishlistCards(grid, list);
      });
  }

  async function addWishlistItemToCart(variantId) {
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = 'cart-icon-bubble';

    if (cartDrawer) {
      sections += ',' + cartDrawer
        .closest('.shopify-section')
        .id
        .replace('shopify-section-', '');
    }

    var body = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: sections,
      sections_url: window.location.pathname
    };

    var response = await fetch(
      (window.theme && theme.routes && theme.routes.cartAdd)
        ? theme.routes.cartAdd
        : '/cart/add.js',
      {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      }
    );

    var data = await response.json();

    if (!response.ok) throw new Error('Wishlist ATC failed');

    if (
      window.customElements
      && customElements.get('product-form')
      && typeof customElements.get('product-form').updateCartIcon === 'function'
    ) {
      customElements.get('product-form').updateCartIcon(data);
    }

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      var shouldOpen =
        (
          theme.settings.afterAtc === 'drawer_desktop'
          && theme.mediaMatches.md
        )
        || theme.settings.afterAtc === 'drawer';

      cartDrawer.renderContents(data, shouldOpen);
    }

    document.dispatchEvent(
      new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: {
          cart: data,
          variantId: Number(variantId)
        }
      })
    );
  }

  function onWishlistPageClick(e) {
    var rm = e.target && e.target.closest
      ? e.target.closest('[data-nb-wl-remove]')
      : null;

    if (rm) {
      e.preventDefault();

      var h = rm.getAttribute('data-product-handle');
      var pid = rm.getAttribute('data-product-id');

      if (!h && !pid) return;

      removeItem(h || pid, pid);

      refreshHeaderAndButtons();
      renderWishlistPage();

      return;
    }

    var atc = e.target && e.target.closest
      ? e.target.closest('[data-nb-wl-atc]')
      : null;

    if (!atc) return;

    e.preventDefault();

    var vid = atc.getAttribute('data-variant-id');
    if (!vid) return;

    atc.disabled = true;
    atc.classList.add('is-loading');

    addWishlistItemToCart(vid)
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        atc.disabled = false;
        atc.classList.remove('is-loading');
      });
  }

  function init() {
    migrateGuestToCustomerIfNeeded();

    refreshHeaderAndButtons();
    renderWishlistPage();

    syncBackendWishlist();

    document.addEventListener('click', onBtnClick, { passive: false });

    if (document.querySelector('[data-nb-wishlist-page]')) {
      document.addEventListener('click', onWishlistPageClick, { passive: false });
    }

    window.NBWishlist = {
      getCount: getCount,
      read: function () { return readList(getActiveKey()); },
      add: addItem,
      remove: removeItem,
      sync: function () {
        refreshHeaderAndButtons();
        syncBackendWishlist();
      },
      rerender: renderWishlistPage
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();